import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetIntegration = <T>({
  integrationName,
}: {
  integrationName: string;
}) => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    integrationConfig: {
      integrationId: string;
      externalId: string;
      integrationName: string;
      integrationAuth: string;
      integrationConfig: string;
      tenantId: string;
      createdAt: string;
      updatedAt: string;
    }[];
  }>(GET_INTEGRATION_QUERY, {
    variables: { tenantId, integrationName },
  });

  return {
    integration: data?.integrationConfig[0] as T,
    error,
    loading,
    refetch,
  };
};

export const GET_INTEGRATION_QUERY = gql`
  query GetIntegration($tenantId: String!, $integrationName: String!) {
    integrationConfig(tenantId: $tenantId, integrationName: $integrationName) {
      integrationId
      externalId
      integrationName
      integrationAuth
      integrationConfig
      tenantId
      createdAt
      updatedAt
    }
  }
`;
